// Returns public user name with shorted last name
const getUserPublicName = ({ firstName = '', lastName = '' }: { firstName: string, lastName: string }): string => {
  if (!firstName && !lastName) {
    return `Scentbird Account`
  }

  const lastNameShorted = lastName
    ? `${lastName.substr(0, 1).toUpperCase()}.`
    : null

  if (firstName && lastNameShorted) {
    return `${firstName} ${lastNameShorted}`
  }

  return firstName || lastNameShorted
}


export default getUserPublicName
